import { CustomHooks } from "@engaging-tech/components"
import React from "react"

import { MagicLinkMessage as MagicLinkMessageView } from "../../features/account"
import SiteLogo from "../../features/ui/components/SiteLogo"
import GradientLayout from "../../layouts/GradientLayout"

export default function MagicLinkMessage() {
  CustomHooks.useFreshChatDeactivate(true)

  return (
    <GradientLayout>
      <MagicLinkMessageView siteLogo={SiteLogo} cancelRoute="/" />
    </GradientLayout>
  )
}
